var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17155",
    "data-name": "Group 17155",
    transform: "translate(-376 -284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(376 284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clock",
    d: "M8.028,0a8.028,8.028,0,1,0,8.028,8.028A8.037,8.037,0,0,0,8.028,0Zm3.818,12.181a.668.668,0,0,1-.946,0L7.555,8.836a.666.666,0,0,1-.2-.473V4.014a.669.669,0,0,1,1.338,0V8.086l3.149,3.149a.668.668,0,0,1,0,.946Zm0,0",
    transform: "translate(378 286)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default __webpack_public_path__ + "static/media/year.667d364e3cb3db5d3bbc9ce3266fd5bd.svg";
export { ForwardRef as ReactComponent };